import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCategoryCarousel {
  constructor(section) {
    this.el = section.el;

    initCarousel(this.el, {
      perPage: 2,
      perMove: 1,
      padding: {
        right: 15,
      },
      arrows: false,
      pagination: false,
      gap: '0.5rem',
      mediaQuery: 'min',
      breakpoints: {
        [unitlessBreakpoints.sm]: {
          perPage: 3,
        },
        [unitlessBreakpoints.md]: {
          perPage: 4,
        },
        [unitlessBreakpoints.lg]: {
          destroy: true,
        },
      },
    });
  }
}
